import axios from 'axios'
import querystring from 'querystring'

// initial state

const state = {
  all: [],
  details: null,
  branches: [],
  members: [],
  events: [],
  media: {
    links: {
      status: {
        num: 0
      },
      general: [],
      social: {
        status: {
          num: 0
        }
      }
    },
    videos: {
      status: {
        num: 0
      },
      data: []
    }
  },
  staff: {
    ownerMembers: {
      status: {
        num: 0
      },
      members: []
    },
    contactMembers: {
      status: {
        num: 0
      },
      members: []
    },
    honoraryMembers: {
      status: {
        num: 0
      },
      members: []
    },
    trainerMembers: {
      status: {
        num: 0
      },
      members: []
    },
    administrationMembers: {
      status: {
        num: 0
      },
      members: []
    }
  }
}

// getters
const getters = {
  list: state => state.all,
  details: state => state.details,
  branches: state => state.branches,
  members: state => state.members,
  events: state => state.events,
  media: state => state.media,
  staff: state => state.staff,
  logoPath: (state, getters, rootState, rootGetters) => rootGetters['config'].API.dojoLogoPath
}

// actions
const actions = {
  getAll: function (context) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getDojos,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password
      })
    )
    .then(
      (response) => {
        context.commit('SET_ALL', response.data)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getDetails: function (context, id) {
    context.commit('SET_DETAILS', null)
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getDojoDetailsById,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        id: id
      })
    )
    .then(
      (response) => {
        context.commit('SET_DETAILS', response.data.dojo[0])
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getBranches: function (context, id) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getDojoBranchesById,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        id: id
      })
    )
    .then(
      (response) => {
        console.log('trying to set branches')
        if (response.data.status.num === 200) {
          context.commit('SET_BRANCHES', response.data.branches)
          console.log(response)
        }
      }
    )
    .catch((error) => console.log(error))
  },
  getMembers: function (context, id) {
    context.commit('SET_MEMBERS', [])
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getMembersByDojoId,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        dojoId: id
      })
    )
    .then(
      (response) => {
        context.commit('SET_MEMBERS', response.data.members)
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getEvents: function (context, id) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getDojoEventsById,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        id: id
      })
    )
    .then(
      (response) => {
        if (response.data.status.num === 200) {
          context.commit('SET_EVENTS', response.data)
        }
        console.log(response)
      }
    )
    .catch((error) => console.log(error))
  },
  getMedia: function (context, id) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getDojoMediaById,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        id: id
      })
    )
    .then(
      (response) => {
        if (response.data.status.num === 200) {
          console.log(response)
          context.commit('SET_MEDIA', response.data)
        }
      }
    )
    .catch((error) => console.log(error))
  },
  getStaff: function (context, id) {
    return axios.post(context.rootGetters['config'].API.baseURL + context.rootGetters['config'].API.getDojoMemberFunctionById,
    querystring.stringify(
      {
        user: context.rootGetters['config'].API.user,
        password: context.rootGetters['config'].API.password,
        id: id
      })
    )
    .then(
      (response) => {
        if (response.data.status.num === 200) {
          context.commit('SET_STAFF', response.data)
          console.log(response)
        }
      }
    )
    .catch((error) => console.log(error))
  }
}

// mutations
const mutations = {
  SET_ALL (state, data) {
    state.all = data.dojos
  },
  SET_DETAILS (state, data) {
    state.details = data
    console.log(state.details)
  },
  SET_BRANCHES (state, data) {
    state.branches = data
  },
  SET_MEMBERS (state, data) {
    state.members = data
  },
  SET_EVENTS (state, data) {
    state.events = data
  },
  SET_MEDIA (state, data) {
    console.log('SET_MEDIA')
    state.media = data
  },
  SET_STAFF (state, data) {
    /*
        if (response.body.contactMembers.status.num === 200) {
          this.staff.contactMembers = response.body.contactMembers.members
        }
        if (response.body.ownerMembers.status.num === 200) {
          this.staff.ownerMembers = response.body.ownerMembers.members
        }
        if (response.body.trainerMembers.status.num === 200) {
          this.staff.trainerMembers = response.body.trainerMembers.members
        }
        if (response.body.honoraryMembers.status.num === 200) {
          this.staff.honoraryMembers = response.body.honoraryMembers.members
        }
        if (response.body.administrationMembers.status.num === 200) {
          this.staff.administrationMembers = response.body.administrationMembers.members
        }
    */
    state.staff = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
